export enum FinancialField {
  PERSONAL_ANNUAL_GROSS_INCOME = 'personalAnnualGrossIncome',
  PERSONAL_NET_WORTH_RANGE = 'personalNetWorthRange',
  MARITAL_STATUS = 'maritalStatus',
}
